export default [
    {
      path:'/searchEnterprise',
      name:'Search',
      component:() => import('./Search')
    }
  ]